import React, { useEffect, useState } from 'react'
import Banner from '../../components/Banner'
import { Col, Container, Row, Table } from 'react-bootstrap'
import { productList } from '../../data/localData'
import { Link, useParams } from 'react-router-dom'
import { GoArrowUpRight } from 'react-icons/go'
import { useDispatch } from 'react-redux'
import { updateModal } from '../../store/slices/modalSlice'

function ProductListing() {

    const params = useParams();
    const dispatch = useDispatch();

    const handleRedirect = (link) => {
        return link.toLowerCase().replace("-", "~").replace(/\s+/g, "-")
    }

    const [productData, setProductData] = useState([]);

    useEffect(() => {
        if (params?.categoryName) {
            const categoryData = productList.find((item) => handleRedirect(item?.label) == params.categoryName)
            if (categoryData) {
                const subCategoryData = categoryData?.data.find((item) => handleRedirect(item?.label) == params.subCategoryName)

                if (subCategoryData?.data?.length > 0) {
                    setProductData(subCategoryData);
                }

                if (!subCategoryData) {
                    setProductData(categoryData?.data[0])
                }
            }
        }
        if (window.location.pathname == "/product") {
            setProductData(productList[0].data[0]);
        }
    }, [params])

    const handleScroll = () => {
        const hash = window.location.hash;
        if (hash) {
            const element = document?.getElementById(`${hash.replace("#", "")}`);
            if (element) {
                const offset = -50; // Set your desired offset
                const rect = element.getBoundingClientRect(); // Get the element's position
                const scrollTop = window.scrollY || document.documentElement.scrollTop;

                // Scroll with offset
                window.scrollTo({
                    top: rect.top + scrollTop + offset,
                    behavior: "smooth" // For smooth scrolling
                });
            }
        }
    }

    useEffect(() => {
        handleScroll();
    }, [window.location.hash]);

    return (
        <div className='product-listing-page'>
            <Banner title={productData?.label} image={productData?.banner} />
            <Container className='product-gap'>
                <Row className='gy-4 gy-md-5'>
                    {
                        productData?.data?.length > 0 &&
                        productData?.data?.map((product, index) => {
                            return (
                                <Col className='col-12' key={index} id={`${handleRedirect(product?.name)}`}>
                                    <div className='product-holder gap-3 gap-lg-4 gap-xl-5 d-grid d-md-flex align-items-center align-items-xxl-start'>
                                        <div className="image-holder">
                                            <img src={product.image} alt="" />
                                        </div>
                                        <div className="content-holder d-grid align-content-between gap-3 gap-xxl-4">
                                            <h4 className='fs-32 fs-md-25 fs-sm-20 m-0 fw-semibold'>{product.name}</h4>
                                            <Table bordered striped className='content-table m-0'>
                                                <tbody>
                                                    {
                                                        product.tableList.map((list, subIndex) => {
                                                            return (
                                                                <tr key={subIndex} className='fs-18 fs-md-16 fs-sm-14'>
                                                                    <td className='fw-semibold' style={{ minWidth: "105px" }}>
                                                                        <span className='ps-2'>{list.label}</span>
                                                                    </td>
                                                                    <td>{list.value}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                            <div className='d-flex'>
                                                <Link to={product.redirectLink} className='new-theme-contra-btn' onClick={() => { dispatch(updateModal(true)) }}>
                                                    Enquire Now
                                                    <span><GoArrowUpRight /></span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>

        </div>
    )
}

export default ProductListing